// Walk a ScratchJr editor project (see Project.getProject / Page.encodePage)
// into a DSL-shaped tree of pages → sprites → scripts, and back.
// dslToProject expects a `projectShell` carrying all non-script data
// (page metadata, sprite positions, md5s, sounds, etc.) — only `scripts`
// arrays are replaced from the DSL.

const {editorScriptsToDSL, dslToEditorScripts} = require('./serialize');

function projectToDSL (project) {
    const out = {pages: []};
    if (!project || !Array.isArray(project.pages)) {
        return out;
    }
    for (const pageId of project.pages) {
        const pageData = project[pageId];
        if (!pageData) {
            continue;
        }
        const dslPage = {id: pageId, sprites: []};
        const spriteIds = Array.isArray(pageData.sprites) ? pageData.sprites : [];
        for (const spriteId of spriteIds) {
            const spr = pageData[spriteId];
            if (!spr) {
                continue;
            }
            if (spr.type && spr.type !== 'sprite') {
                continue;
            }
            dslPage.sprites.push({
                id: spriteId,
                name: spr.name,
                scripts: editorScriptsToDSL(spr.scripts || [])
            });
        }
        out.pages.push(dslPage);
    }
    return out;
}

function dslToProject (dsl, projectShell) {
    if (!projectShell) {
        return null;
    }
    const out = JSON.parse(JSON.stringify(projectShell));
    if (!dsl || !Array.isArray(dsl.pages)) {
        return out;
    }
    for (const dslPage of dsl.pages) {
        const pageData = out[dslPage.id];
        if (!pageData) {
            continue;
        }
        const sprites = Array.isArray(dslPage.sprites) ? dslPage.sprites : [];
        for (const dslSprite of sprites) {
            const spr = pageData[dslSprite.id];
            if (!spr) {
                continue;
            }
            spr.scripts = dslToEditorScripts(dslSprite.scripts || []);
        }
    }
    return out;
}

module.exports = {
    projectToDSL,
    dslToProject
};
